module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/253.dd2bf0e8.png";